import * as _ from 'underscore'
import { ITemplate as ITemplate_Mvc, Templates as Templates_Mvc, Template as Template_Mvc } from 'mappMvc/compile'

export interface ITemplate extends ITemplate_Mvc {
    base_blocked: string;
    base_centered: string;
    base_content: string;
    base_missingTenant: string;
    base_tabbed: string;
    forms_login: string;
    header_bar: string;
    header_branding_base: string;
    header_branding_hex_logo: string;
    header_branding_mae_logo: string;
    header_horizontalSwitch: string;
    header_menuItemsSwitch: string;
    header_navigation_bar: string;
    header_noUserBar: string;
    header_user: string;
    layouts_uiElements_hBarCheckbox: string;
    logs_displayTimeAgo: string;
    logs_messageCell: string;
    logs_table: string;
    mappEnterpriseStudio: string;
    navigations_tabItems: string;
};
export var Templates: ITemplate = _.extend({}, Templates_Mvc, {
    base_blocked: 'base_blocked',
    base_centered: 'base_centered',
    base_content: 'base_content',
    base_missingTenant: 'base_missingTenant',
    base_tabbed: 'base_tabbed',
    forms_login: 'forms_login',
    header_bar: 'header_bar',
    header_branding_base: 'header_branding_base',
    header_branding_hex_logo: 'header_branding_hex_logo',
    header_branding_mae_logo: 'header_branding_mae_logo',
    header_horizontalSwitch: 'header_horizontalSwitch',
    header_menuItemsSwitch: 'header_menuItemsSwitch',
    header_navigation_bar: 'header_navigation_bar',
    header_noUserBar: 'header_noUserBar',
    header_user: 'header_user',
    layouts_uiElements_hBarCheckbox: 'layouts_uiElements_hBarCheckbox',
    logs_displayTimeAgo: 'logs_displayTimeAgo',
    logs_messageCell: 'logs_messageCell',
    logs_table: 'logs_table',
    mappEnterpriseStudio: 'mappEnterpriseStudio',
    navigations_tabItems: 'navigations_tabItems'
});
export var Template = _.extend({}, Template_Mvc, {
    [Templates.base_blocked]: `<main class="mapp-studio-main">
    <header class="mapp-header" data-bind="template: mapp.Templates.header_noUserBar"></header>
    <header class="mapp-navigation"></header>
    <section class="mapp-content no-gutter mapp-cell-1-1">
        <section class="form-wrapper base-form-theme no-gutter mapp-cell-3-12 margin-top-gutter">
            <div class="fluid-items content mapp-row">
                <label class="label" data-bind="text: mapp.Localization.Errors.AccessDenied"></label>
            </div>
        </section>
    </section>
    <section class="mapp-modal-container">
    </section>
</main>`,
    [Templates.base_centered]: `<main class="mapp-studio-main">
    <header class="mapp-header">
        <!-- ko template: { name: mapp.Templates.header_branding_base, data: $data }-->
        <!-- /ko -->
    </header>
    <header class="mapp-navigation"></header>
    <section class="mapp-content no-gutter mapp-cell-1-1">
        <section class="form-wrapper base-form-theme no-gutter mapp-cell-3-12 margin-top-gutter">
            <div class="mapp-loading-area">
                <!-- ko template: mapp.Templates.general_loading -->
                <!-- /ko -->
                <!-- ko template: { name: form.template, data: form } -->
                <!-- /ko -->
            </div>
        </section>
    </section>
    <section class="mapp-modal-container">
    </section>
</main>`,
    [Templates.base_content]: `<section class="content-section">
    <!-- ko with: navigation -->
    <nav class="left-menu no-gutter mapp-cell-2-12" data-bind="template: { name: template, data: $data }"></nav>
    <!-- /ko -->
    <!--ko with: activeView -->
    <div class="right-content no-gutter mapp-cell-10-12" data-bind="template: { name: template, data: $data }"></div>
    <!-- /ko-->
</section>`,
    [Templates.base_missingTenant]: `<main class="mapp-studio-main">
    <header class="mapp-header" data-bind="template: mapp.Templates.header_noUserBar"></header>
    <header class="mapp-navigation"></header>
    <section class="mapp-content no-gutter mapp-cell-1-1">
        <section class="form-wrapper base-form-theme no-gutter mapp-cell-3-12 margin-top-gutter">
            <div class="fluid-items content mapp-row">
                <label class="label" data-bind="text: mapp.Localization.Errors.MissingTenant"></label>
            </div>
        </section>
    </section>
    <section class="mapp-modal-container">
    </section>
</main>`,
    [Templates.base_tabbed]: `<section class="content-section">
    <div class="section-content">
        <!-- ko with: navigation -->
        <nav data-bind="template: { name: template, data: $data }"></nav>
        <!-- /ko -->
        <!--ko with: activeView -->
        <content class="tab-content" data-bind="template: { name: template, data: $data }"></content>
        <!-- /ko-->
    </div>
</section>`,
    [Templates.forms_login]: `<div class="form login">
    <div class="fluid-items full-line-items no-gaps mapp-row" data-bind="foreach: uiElements">
        <!-- ko template: { name: template, data: $data } -->
        <!-- /ko -->
    </div>
</div>
<div class="form-action">
    <a class="hehe-icons-check" data-bind="click: clickSubmit, text: mapp.Localization.Login.Login"></a>
</div>`,
    [Templates.header_bar]: `<!-- ko template: { name: mapp.Templates.header_branding_base, data: $data }-->
<!-- /ko -->
<!-- ko if: user.InvalidAccount -->
<div class="invalid-license-wrapper">
    <span data-bind="text: mapp.Localization.License.InvalidAccount"></span>
</div>
<!-- /ko -->
<!-- ko if: user.ServiceDown -->
<div class="invalid-license-wrapper">
    <span data-bind="text: mapp.Localization.License.ServiceDown"></span>
</div>
<!-- /ko -->
<section class="mapp-user" data-bind="template: { name: user.template, data: user }"></section>

<!-- ko with: mapp.Util.StudioNotification -->
<section class="studio-notification" data-bind="template: { name: template, data: $data}, element: element, css: css, style: {left: offset}, event: {mouseenter: pauseClose, mouseleave: resumeClose}"></section>
<!-- /ko -->`,
    [Templates.header_branding_base]: `<a href="#" class="mapp-logo">
    <div>

        <!-- ko template: { name: mapp.Templates.header_branding_hex_logo } --> <!-- /ko -->

        <div id="vert-sep"></div>

        <!-- ko template: { name: mapp.Templates.header_branding_mae_logo } --> <!-- /ko -->

        <div id="mae-title">
            <span>M.App</span>
            <span>Enterprise</span>
        </div>
    </div>
</a>`,
    [Templates.header_branding_hex_logo]: `<svg class="hex" width="28.711mm" height="33.937mm" version="1.1" viewBox="0 0 28.711 33.937" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:ns="&#38;ns_ai;" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
    <defs>
        <clipPath id="a">
            <rect x="9.6036" y="5.4716" width="109.61" height="128.26" opacity=".357" stroke-width=".92662" />
        </clipPath>
    </defs>
    <metadata>
        <rdf:RDF>
            <cc:Work rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title />
            </cc:Work>
        </rdf:RDF>
    </metadata>
    <g transform="translate(-.86043 -1.65)">
        <switch transform="matrix(.26458 0 0 .26458 -1.9706 .20227)" clip-path="url(#a)">
            <foreignObject width="1" height="1" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" />
            <g ns:extraneous="self">
                <path class="st0" d="m65.78 68v-61.9l-54.35 31.37-0.7 0.42-0.03 63.06h35.04l18.02 31.81 54.9-31.7v-63.59zm49.74 31.48h-31.27l31.47-53.96v53.95zm-0.84-58.01-33.83 58.01h-15.07v-29.78zm-48.9 59.48h14.2l-14.2 24.36zm-2.93-1.47h-14.55l-8.41-14.84 22.96-13.25zm-23.69-16.11-8.49-14.98 32.18-55.73v57.04zm22.41-71.45-31.74 54.98-15.64-27.61zm-33.44 57.94-15.95 27.62v-55.78zm0.84 1.48 7.65 13.51-23.17 13.37zm-14.78 28.14 23.15-13.37 7.57 13.37zm34.94 1.47h13.72v24.22zm34.26 0h29.59l-44.6 25.76z" />
                <path class="st0" d="m415.81 94.16v-37.87l-13.93 37.24h-4.43l-13.93-37.55v38.19h-5.38v-44.9h8.11l13.55 36.54 13.49-36.54h7.92v44.9h-5.4z" />
                <path class="st0" d="m433.09 94.16v-7.54h7.47v7.54z" />
                <path class="st0" d="m481.02 94.16-3.67-10.64h-19.51l-3.61 10.64h-5.7l15.83-44.9h6.59l15.9 44.9zm-13.49-39.27-7.92 23.3h15.9z" />
                <path class="st0" d="m516.73 91.81c-2.09 1.96-5.06 3.23-8.8 3.23-3.48 0-7.6-1.65-9.31-4.56v17.42h-5.38v-45.72h4.75l0.38 4.18c1.84-3.23 5.95-5 9.56-5 3.93 0 6.97 1.33 9.06 3.48 3.04 3.1 4.62 7.98 4.62 13.3 0 5.51-1.65 10.57-4.88 13.67zm-9.69-25.9c-2.34 0-3.93 0.95-5.19 2.09-2.66 2.34-3.55 6.21-3.55 10.2s0.89 7.85 3.55 10.2c1.27 1.14 2.85 2.09 5.19 2.09 7.16 0 9.06-6.4 9.06-12.29s-1.9-12.29-9.06-12.29z" />
                <path class="st0" d="m554.09 91.81c-2.09 1.96-5.07 3.23-8.8 3.23-3.48 0-7.6-1.65-9.31-4.56v17.42h-5.38v-45.72h4.75l0.38 4.18c1.84-3.23 5.95-5 9.56-5 3.93 0 6.97 1.33 9.06 3.48 3.04 3.1 4.62 7.98 4.62 13.3-0.01 5.51-1.65 10.57-4.88 13.67zm-9.69-25.9c-2.34 0-3.93 0.95-5.19 2.09-2.66 2.34-3.55 6.21-3.55 10.2s0.89 7.85 3.55 10.2c1.27 1.14 2.85 2.09 5.19 2.09 7.16 0 9.06-6.4 9.06-12.29s-1.9-12.29-9.06-12.29z" />
                <path class="st0" d="m583.27 94.16v-44.9h30.02v5.19h-24.38v13.68h21.41v5.32h-21.41v15.52h24.38v5.19z" />
                <path class="st0" d="m642.92 94.16v-20.33c0-4.81-1.96-7.66-7.03-7.66-3.1 0-5.57 2.03-6.97 4.94-1.08 2.34-1.14 5.7-1.14 8.17v14.88h-5.38v-32.05h4.69l0.44 4.81c1.65-3.67 6.08-5.64 9.69-5.64 7.28 0 11.08 4.37 11.08 11.78v21.09h-5.38z" />
                <path class="st0" d="m669.64 94.6c-6.9 0-8.8-4.37-8.8-8.68v-19.18h-6.21v-4.62h6.21v-8.17l5.38-1.27v9.44h9.5v4.62h-9.5v18.56c0 3.1 1.33 4.37 4.31 4.37 2.28 0 5.51-0.57 5.51-0.57v4.62c-1.46 0.37-3.43 0.88-6.4 0.88z" />
                <path class="st0" d="m708.96 79.91h-22.67c0 2.91 1.14 6.08 3.1 8.04 1.46 1.46 3.42 2.28 5.89 2.28 2.53 0 4.62-0.7 5.95-2.09 0.89-0.89 1.46-1.77 1.9-3.48h5.26c-0.44 3.17-2.34 6.14-4.94 7.92-2.28 1.52-5.13 2.41-8.17 2.41-4.5 0-8.17-1.9-10.64-4.81-2.66-3.1-3.99-7.35-3.99-11.91 0-3.86 0.7-7.28 2.47-10.26 2.28-3.86 6.52-6.71 12.1-6.71 4.12 0 7.41 1.58 9.75 4.12 2.6 2.85 4.12 6.97 4.05 11.27zm-7.41-11.15c-1.33-1.77-3.48-2.91-6.33-2.91-5.83 0-8.68 4.75-8.8 9.44h17.1c-0.01-2.41-0.7-4.82-1.97-6.53z" />
                <path class="st0" d="m732.38 67.12c-2.53 0-4.62 1.14-6.08 2.53-2.6 2.47-2.91 6.9-2.91 10.26v14.25h-5.32v-32.05h4.75l0.44 5.64c1.65-3.93 5.51-5.83 9.56-5.83 0.82 0 1.71 0.06 2.53 0.19v5.26c-0.94-0.19-2.02-0.25-2.97-0.25z" />
                <path class="st0" d="m765.88 91.81c-2.09 1.96-5.07 3.23-8.8 3.23-3.48 0-7.6-1.65-9.31-4.56v17.42h-5.38v-45.72h4.75l0.38 4.18c1.84-3.23 5.95-5 9.56-5 3.93 0 6.97 1.33 9.06 3.48 3.04 3.1 4.62 7.98 4.62 13.3-0.01 5.51-1.65 10.57-4.88 13.67zm-9.69-25.9c-2.34 0-3.93 0.95-5.19 2.09-2.66 2.34-3.55 6.21-3.55 10.2s0.89 7.85 3.55 10.2c1.27 1.14 2.85 2.09 5.19 2.09 7.16 0 9.06-6.4 9.06-12.29s-1.9-12.29-9.06-12.29z" />
                <path class="st0" d="m794.37 67.12c-2.53 0-4.62 1.14-6.08 2.53-2.6 2.47-2.91 6.9-2.91 10.26v14.25h-5.32v-32.05h4.75l0.44 5.64c1.65-3.93 5.51-5.83 9.56-5.83 0.82 0 1.71 0.06 2.53 0.19v5.26c-0.94-0.19-2.02-0.25-2.97-0.25z" />
                <path class="st0" d="m803.99 54.77v-6.33h6.27v6.33zm0.38 39.39v-32.05h5.51v32.04h-5.51z" />
                <path class="st0" d="m842.87 91.37c-2.47 2.53-6.27 3.61-10.45 3.61-3.99 0-7.66-0.95-10.39-3.61-1.96-1.9-3.1-4.62-3.1-7.35h5.38c0.06 2.22 1.08 3.86 2.6 5 1.46 1.08 3.74 1.46 5.76 1.46 2.22 0 4.24-0.38 5.89-1.77 0.89-0.7 1.58-2.03 1.58-3.48 0-2.41-1.71-4.12-5-4.56l-7.22-0.95c-4.81-0.76-7.85-3.74-7.85-8.61 0-2.47 1.2-4.81 2.66-6.27 2.09-2.15 5.45-3.55 9.44-3.55 4.24 0 8.04 1.33 10.2 4.05 1.39 1.71 2.28 3.55 2.28 6.14h-5.38c-0.06-1.65-0.89-3.17-1.84-3.99-1.33-1.2-3.1-1.71-5.26-1.71-1.27 0-2.22 0-3.74 0.63-2.03 0.82-3.23 2.53-3.23 4.31 0 2.66 1.65 3.8 4.31 4.18 1.77 0.25 4.31 0.51 7.73 1.08 4.56 0.76 8.17 4.05 8.17 8.87-0.01 2.79-1.02 4.94-2.54 6.52z" />
                <path class="st0" d="m880.42 79.91h-22.67c0 2.91 1.14 6.08 3.1 8.04 1.46 1.46 3.42 2.28 5.89 2.28 2.53 0 4.62-0.7 5.95-2.09 0.89-0.89 1.46-1.77 1.9-3.48h5.26c-0.44 3.17-2.34 6.14-4.94 7.92-2.28 1.52-5.13 2.41-8.17 2.41-4.5 0-8.17-1.9-10.64-4.81-2.66-3.1-3.99-7.35-3.99-11.91 0-3.86 0.7-7.28 2.47-10.26 2.28-3.86 6.52-6.71 12.1-6.71 4.12 0 7.41 1.58 9.75 4.12 2.6 2.85 4.12 6.97 4.05 11.27zm-7.41-11.15c-1.33-1.77-3.48-2.91-6.33-2.91-5.83 0-8.68 4.75-8.8 9.44h17.1c-0.01-2.41-0.71-4.82-1.97-6.53z" />
                <path class="st1" d="m217.13 127.54-0.01-116.29h116.46v98.76l-17.65 17.53zm-5.1 5.22h126.8v-126.8h-126.8z" />
                <polygon class="st2" points="295.56 76.95 295.56 91.17 299.04 91.17 299.04 76.97" />
                <polygon class="st2" points="299.07 68.57 299.07 56.58 295.56 56.58 295.56 60.68 295.56 68.57" />
                <polygon class="st2" points="" />
                <polygon class="st2" points="322.79 71.45 322.8 71.45" />
                <polygon class="st2" points="326.6 50.35 322.91 47.96 322.91 56.58 326.6 58.98" />
                <polygon class="st1" points="322.91 56.58 322.91 50.92 322.91 47.96 299.07 47.96 299.07 56.58" />
                <polygon class="st1" points="319.67 76.97 319.67 71.45 319.67 68.57 299.07 68.57 299.04 76.97" />
                <polygon class="st1" points="322.99 99.73 322.99 94.08 322.99 94.07 322.99 91.17 299.04 91.17 299.04 99.72" />
                <polygon class="st1" points="295.56 91.17 295.56 47.96 289.85 47.96 289.84 99.72 295.56 99.73" />
                <polygon class="st3" points="295.56 56.58 299.07 58.98 326.6 58.98 322.91 56.58 298.66 56.58" />
                <polygon class="st3" points="295.56 76.97 299.07 79.36 323.21 79.36 322.91 76.97 298.66 76.97" />
                <polygon class="st2" points="326.6 93.56 322.99 91.17 322.99 99.73 326.6 101.84" />
                <polygon class="st2" points="323.21 70.86 319.67 68.57 319.67 76.97 323.21 79.36" />
                <polygon class="st4" points="299.07 56.58 299.07 47.96 295.56 47.96 295.56 50.9 295.56 56.58" />
                <polygon class="st5" points="286.2 47.96 286.2 99.73 289.84 99.72 289.85 47.96" />
                <polygon class="st4" points="299.04 76.97 299.07 68.57 295.56 68.57 295.56 76.95" />
                <rect class="st4" x="295.56" y="91.17" width="3.48" height="8.55" />
                <polygon class="st3" points="289.84 101.84 326.6 101.84 322.99 99.73 286.2 99.73" />
                <path class="st1" d="m268.43 99.72v-36.94l-13.43 36.21h-6.94l-13.14-36.03v36.76h-9.35v-51.76h12.87l13.41 36.87 13.65-36.87h12.05v51.76z" />
                <rect class="st5" x="225.58" y="47.96" width="3.65" height="51.76" />
                <polygon class="st2" points="238.45 101.84 234.92 99.72 234.92 62.96 238.45 72.63" />
                <polygon class="st3" points="228.85 101.84 238.45 101.84 234.92 99.72 225.58 99.72" />
                <polygon class="st3" points="251.33 101.11 258.22 101.11 254.99 98.99 248.06 98.99" />
                <polygon class="st2" points="280.77 101.84 277.55 99.72 277.55 47.96 280.77 47.96" />
                <polygon class="st3" points="271.7 101.84 280.77 101.84 277.55 99.72 268.43 99.72" />
                <polygon class="st4" points="238.45 72.63 234.92 62.96 234.92 47.96 238.45 47.96" />
                <polygon class="st2" points="258.22 101.11 254.99 98.99 268.43 62.78 268.43 73.64" />
                <polygon class="st2" points="251.86 84.83 253.82 79.51 243.14 51 238.45 47.96" />
                <line class="st6" x1="165.35" x2="165.35" y1="1.98" y2="134.75" />
            </g>
        </switch>
    </g>
</svg>
`,
    [Templates.header_branding_mae_logo]: `<svg class="mae" enable-background="new 0 0 1024 1024" version="1.1" viewBox="0 0 1024 1024" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><metadata><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title /></cc:Work></rdf:RDF></metadata>

    <style type="text/css">
        .st0 {
            fill: #FFFFFF;
        }

        .st1 {
            fill: #0D794D;
        }

        .st2 {
            fill: #B4B4B4;
        }
    </style>

    <rect class="st0" width="1024" height="1024" />
    <path class="st1" d="M41.2,981.8L41.1,42.7h940.5v797.6L839,981.8H41.2z M0,1024h1024V0H0V1024z" />
    <polygon class="st2" points="894.5 500.9 894.5 500.9" />
    <polygon class="st2" points="894.5 500.9 894.5 500.9" />
    <polygon class="st1" transform="matrix(1.1539 0 0 1 -137.82 0)" points="895.5 311.2 702.9 311.2 702.9 380.8 895.5 380.8 895.5 335.1" fill="#0d794d" />
    <polygon class="st1" transform="matrix(1.192 0 0 1 -166.94 0)" points="869.3 545.5 869.3 500.9 869.3 500.9 869.3 477.6 702.9 477.6 702.7 545.5" fill="#0d794d" />
    <polygon class="st1" transform="matrix(1.1595 0 0 1 -142.91 0)" points="896.1 683.6 896.1 683.5 896.1 660.2 702.7 660.2 702.7 729.2 896.1 729.2" fill="#0d794d" />
    <polygon class="st1" transform="matrix(2.568 0 0 1 -939.25 0)" points="599 729.2 628.4 729.2 628.5 311.2 599 311.2" fill="#0d794d" />
    <path class="st1" d="m455.5 729.2v-298.3l-108.5 292.4h-56l-106.1-291v296.9h-75.5v-418h104l108.2 297.7 110.3-297.7h97.3v418h-73.7z" />
    <rect class="st1" x="109.4" y="311.2" width="29.4" height="418" />

</svg>
`,
    [Templates.header_horizontalSwitch]: `<div class="horizontal-switch" data-bind="foreach: items">
    <!-- ko if: visible -->
    <a data-bind="click: toggle, css: css" class="switch-item switch-icon">
    </a>
    <!-- /ko -->
</div>`,
    [Templates.header_menuItemsSwitch]: `<div class="menuItems-switch" data-bind="foreach: items">
    <!-- ko if: visible -->
    <a data-bind="click: click, css: css" class="switch-item switch-icon">
        <span data-bind="text: label"></span>
    </a>
    <!-- /ko -->
</div>`,
    [Templates.header_navigation_bar]: `<nav>
    <!-- ko foreach: items -->
    <!-- ko if: visible -->
    <a data-bind="click: click, css: css" class="navigation-item navigation-icon">
        <span data-bind="text: label"></span>
    </a>
    <!-- /ko -->
    <!-- /ko -->
</nav>`,
    [Templates.header_noUserBar]: `<!-- ko template: { name: mapp.Templates.header_branding_noLic, data: $data }-->
<!-- /ko -->`,
    [Templates.header_user]: `<div class="icon user-icon hehe-icons-user" data-bind="event: { mousedown: mouseDown, mouseup: mouseUp }">
    <img data-bind="attr: { src: imageSrc }" />
</div>
<div class="menu">
    <div class="text">
        <span data-bind="text: mapp.Localization.Login.Welcome"></span><span>&nbsp;</span>
        <span class="fullname" data-bind="text: fullName, attr: { title: fullName }"></span>
    </div>
    <div class="text">
        <i>
            <span data-bind="text: mapp.DefaultLocalization.License.LicensedTo"></span>
            <b><span data-bind="text: accountName"></span></b>
        </i>
    </div>
    <div class="actions">
        <a href="#" data-bind="click: logout, text: mapp.Localization.Login.Logout"></a>
        <!-- ko if: settingsVisible --><a href="#" data-bind="click: settings, text: mapp.Localization.Login.Settings"></a><!-- /ko -->
    </div>
</div>`,
    [Templates.layouts_uiElements_hBarCheckbox]: `<!-- ko if: hasLOffset -->
<div class="mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper hBar-checkbox-widget-wrapper" data-bind="visible: visible, css: css">
    <!-- ko template: { name: label.template, data: label } -->
    <!-- /ko -->
    <!-- ko template: { name: widget.template, data: widget } -->
    <!-- /ko -->
</div>
<!-- ko if: hasROffset -->
<div class="mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.logs_displayTimeAgo]: `<span data-bind="text: item.displayTimeAgo, attr: { title: item.displayTime }"></span>`,
    [Templates.logs_messageCell]: `<span class="action" data-bind="text: mapp.Util.getProperty(item, property.key), click: $parents[2].toggleStackTrace.bind($data, item)"></span>`,
    [Templates.logs_table]: `<div class="section-table-header">
    <div data-bind="click: table.clickDeleteSelected, css: {'active': $parent.table.isDeleteActive}">
        <a class="icon hehe-icons-delete">
            <span data-bind="text: mapp.Localization.Delete"></span>&nbsp;<span class="selected-count" data-bind="text: $parent.table.selectionDeleteCountLabel"></span>
        </a>
        </div>
    <div data-bind="click: clickDownloadLog, css: {'active': isDownloadActive}">
        <a class="icon hehe-icons-import">
            <span data-bind="text: downloadLabel"></span>
        </a>
    </div>
</div>
<div class="table-wrapper logs-table no-gutter mapp-cell-1-1" data-bind="with: table">
    <table class="base-table">
        <thead data-bind="template: { name: mapp.Templates.table_header, data: $data }"></thead>
        <tbody data-bind="foreach: { data: view, as: 'item' }">
            <tr>
                <!-- ko if: $parent.isSelectionOn -->
                <td>
                    <div class="checkbox" data-bind="css: { 'hehe-icons-check' : $parent.isSelected(item) }, click: $parent.toggleSelection"></div>
                </td>
                <!-- /ko -->
                <!-- ko foreach: { data: $parent.properties, as: 'property' } -->
                <td data-bind="template: property.template, css: { 'column-autowidth' : property.autoWidth }"></td>
                <!-- /ko -->
            </tr>
            <!-- ko if: item.isStackTraceVisible -->
            <tr>
                <td colspan="4">
                    <pre class="stacktrace-wrapper"><code dir="ltr" data-bind="text: item.stackTrace"></code></pre>
                </td>
            </tr>
            <!-- /ko -->
        </tbody>
    </table>
    <!-- ko template: { name: mapp.Templates.table_empty, data: $data }-->
    <!-- /ko -->
    <!-- ko template: { name: mapp.Templates.table_pager, data: $data }-->
    <!-- /ko -->
</div>`,
    [Templates.mappEnterpriseStudio]: ` <div data-bind="template: { name: template, data: $data }"></div>
`,
    [Templates.navigations_tabItems]: `<ul class="tabbed-navigation" data-bind="foreach: items">
    <li data-bind="click: click, css: { selected: isSelected }">
        <a data-bind="css: css">
            <span data-bind="text: label"></span>
        </a>
    </li>
</ul>`
});